import {
  Avatar,
  Button,
  Checkbox,
  Collapse,
  Dialog,
  FormControl,
  Grid,
  IconButton,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  makeStyles,
  MenuItem,
  Paper,
  Select,
  Slide,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
} from "@material-ui/core";
import AssignmentIndIcon from "@material-ui/icons/AssignmentInd";
import CloseIcon from "@material-ui/icons/Close";
import ExpandLess from "@material-ui/icons/ExpandLess";
import ExpandMore from "@material-ui/icons/ExpandMore";
import GroupAddIcon from "@material-ui/icons/GroupAdd";
import MyLocationIcon from "@material-ui/icons/MyLocation";
import SettingsIcon from "@material-ui/icons/Settings";
import WebIcon from "@material-ui/icons/Web";
import { DatePicker } from "@material-ui/pickers";
import { StyledTableRow } from "components/common/Table";
import withAdminLayout from "components/HoC/withAdminLayout";
import { format } from "date-fns";
import { useFormik } from "formik";
import { VISA_TYPE_ID } from "libs/configs/constant";
import useAdminModalLoading from "libs/hooks/useAdminModalLoading";
import { get, isError } from "lodash";
import mime from "mime";
import CertifyingAgency from "pages/admin/dashboard/components/certifyingAgency";
import CheckStatus from "pages/admin/dashboard/components/checkStatus";
import DocumentNationality from "pages/admin/dashboard/components/documentNationality";
import Endorsement from "pages/admin/dashboard/components/endorsement";
import Notifications from "pages/admin/dashboard/components/notifications";
import RequestDocumentChart from "pages/admin/dashboard/components/requestDocumentChart";
import RequestTypeChart from "pages/admin/dashboard/components/requestTypeChart";
import VisaChart from "pages/admin/dashboard/components/visaChart";
import React, { useEffect, useState } from "react";
import { Responsive, WidthProvider } from "react-grid-layout";
import "react-grid-layout/css/styles.css";
import { useDispatch, useSelector } from "react-redux";
import "react-resizable/css/styles.css";
import { setDialogDetailOpen } from "redux/modules/dashboardSlice";
import { getMasterData, selectMasterData } from "redux/modules/masterSlice";
import DashboardService from "services/DashboardService";
import DatetimeService from "services/DatetimeService";
import ReportService from "services/ReportService";
import * as yup from "yup";

const useStyles = makeStyles((theme) => ({
  paper: {
    padding: theme.spacing(4),
    borderRadius: 16,
  },
  layout: {
    width: "100%",
    height: "100%",
  },
  setting: {
    cursor: "pointer",
    display: "flex",
    justifyContent: "space-between",
    padding: "0px 10px",
  },
  rounded: {
    backgroundColor: "dimgray",
    width: "30px",
    height: "30px",
  },
  editMode: {
    display: "flex",
    alignItems: "center",
  },
  editText: {
    marginRight: "15px",
    color: "#2dce98",
    fontWeight: "500",
    fontSize: "16px",
  },
  wrapChart: {
    borderRadius: "9px",
    boxShadow: "0 3px 17px 0 rgb(126 126 126 / 15%)",
    backgroundColor: "white",
    padding: 5,
  },
  wrapFilter: {
    display: "flex",
    marginBottom: 15,
  },
}));

const ResponsiveReactGridLayout = WidthProvider(Responsive);
const defaultlayout = [
  { i: "a", x: 0, y: 0, w: 4, h: 5, isResizable: false },
  { i: "b", x: 4, y: 0, w: 4, h: 5, isResizable: false },
  { i: "c", x: 8, y: 0, w: 4, h: 5, isResizable: false },

  { i: "d", x: 0, y: 4, w: 8, h: 5, isResizable: false },
  { i: "e", x: 8, y: 4, w: 4, h: 5, isResizable: false },

  { i: "f", x: 0, y: 9, w: 4, h: 5, isResizable: false },
  { i: "g", x: 4, y: 9, w: 4, h: 5, isResizable: false },
  { i: "h", x: 8, y: 9, w: 4, h: 5, isResizable: false },

  { i: "i", x: 0, y: 14, w: 7, h: 5, isResizable: false },
  { i: "j", x: 7, y: 14, w: 5, h: 5, isResizable: false },
];

const originalLayouts = {};
// const originalLayouts = {};
// const originalLayouts = getFromLS("layouts") || {};
function DashboardPage() {
  const classes = useStyles();
  const [editMode, setEditMode] = useState(false);
  const dispatch = useDispatch();
  const [layout, setlayout] = useState(
    JSON.parse(JSON.stringify(originalLayouts))
  );
  const flDate = DatetimeService.getFirstAndLastDayOfMonth(new Date());

  const [startDate, setStartDate] = useState(flDate.firstDate);
  const [endDate, setEndDate] = useState(flDate.lastDate);
  const [condition, setcondition] = useState(false);
  const [dashboardData, setDashboardData] = useState({});
  const { showAdminLoading, hideAdminLoading } = useAdminModalLoading();
  const { dialogDetailOpen } = useSelector((state) => state.dashboard);

  const [filters, setFilters] = useState([]);

  useEffect(() => {
    async function mergedFetchData() {
      await dispatch(
        getMasterData({
          // smartservice: true,
          // VisaTypeConfig: true,
          ActivitiesConfig: true,
        })
      );

      // await fetchData();
    }
    mergedFetchData();
  }, [dispatch]);

  useEffect(() => {
    async function fetchData() {
      try {
        showAdminLoading();
        const res = await DashboardService.getDashboardLayout();
        if (res.status && res.results) {
          const layout = JSON.parse(res.results);
          console.log(layout);
          setlayout(layout);
        }

        await getData();
        hideAdminLoading();
      } catch (error) {
        hideAdminLoading();
        console.error(error);
      }
    }
    fetchData();
  }, []);

  const handleSearch = async () => {
    showAdminLoading();
    await getData();
    hideAdminLoading();
  };

  const getData = async () => {
    const _startDate = startDate
      ? format(new Date(startDate), "yyyy-MM-dd")
      : null;
    const _endDate = endDate ? format(new Date(endDate), "yyyy-MM-dd") : null;

    const _flDate = DatetimeService.getFirstAndLastDayOfYear(
      new Date(startDate)
    );

    const bodyTime = {
      startDate: _startDate,
      endDate: _endDate,
      isComplete: condition,
    };

    const body = {
      endorsementRegion: bodyTime,
      // documentType: bodyTime,
      documentTypeRequest: bodyTime,
      visaType: bodyTime,
      documentList: bodyTime,
      departmentResult: bodyTime,
      news: bodyTime,
      notifications: bodyTime,
      webboard: bodyTime,
      documentNationalityRequest: bodyTime,
      documentStatusRequest: bodyTime,
      resultQualificationEndorsement: {
        startDate: format(new Date(_flDate.firstDate), "yyyy-MM-dd"),
        endDate: format(new Date(_flDate.lastDate), "yyyy-MM-dd"),
      },
      topIndustries: { ...bodyTime, top: 5 },
    };

    const res = await DashboardService.getDashboardData(body);
    if (res.status) {
      setDashboardData(res.results);
    }
  };

  const onLayoutChange = async (layout, layouts) => {
    // saveToLS("layouts", layouts);
    setlayout(layouts);
  };

  const handleClose = (body) => {
    dispatch(setDialogDetailOpen(false));
  };

  const handleViewAll = (body) => {
    dispatch(setDialogDetailOpen(true));
  };

  const handleDownload = async () => {
    const _endDate = endDate ? format(new Date(endDate), "yyyy-MM-dd") : null;
    const body = {
      endDate: _endDate,
    };
    try {
      showAdminLoading();
      const res = await DashboardService.getReportDashboard(body);

      const blobFile = new File([res], "benefits.pdf", {
        type: mime.getType(".pdf"),
      });

      window.open(URL.createObjectURL(blobFile, "benefits.pdf"), "_blank");

      await getData();
      hideAdminLoading();
    } catch (error) {
      hideAdminLoading();
      console.error(error);
    }
  };

  return (
    <Paper className={classes.paper}>
      {/* <AdminTitle
        title="Dashboard"
      // subTitle="Number of successful applicants by targeted industries"
      /> */}
      <DashboardDetailDialog
        open={dialogDetailOpen}
        onClose={handleClose}
        startDate={startDate}
        endDate={endDate}
        filters={filters}
      />

      <div className={classes.setting}>
        <div className={classes.wrapFilter}>
          <FormControl
            variant="outlined"
            className={classes.formControl}
            style={{ marginRight: 10 }}
          >
            <DatePicker
              className={classes.formControl}
              inputVariant="outlined"
              openTo="year"
              format="DD-MM-YYYY"
              size="small"
              label="Start Date"
              views={["year", "month", "date"]}
              value={startDate}
              name={`startDate`}
              onChange={(date) => {
                setStartDate(date.format("YYYY-MM-DD"));
              }}
            />
          </FormControl>
          <FormControl
            variant="outlined"
            className={classes.formControl}
            style={{ marginRight: 10 }}
          >
            <DatePicker
              className={classes.formControl}
              inputVariant="outlined"
              openTo="year"
              format="DD-MM-YYYY"
              size="small"
              label="End Date"
              views={["year", "month", "date"]}
              value={endDate}
              name={`endDate`}
              onChange={(date) => {
                setEndDate(date.format("YYYY-MM-DD"));
              }}
            />
          </FormControl>
          <FormControl
            variant="outlined"
            className={classes.formControl}
            style={{ marginRight: 10 }}
            size="small"
          >
            <Select
              value={condition}
              onChange={(e) => {
                setcondition(e.target.value);
              }}
            >
              <MenuItem value={false}>ทั้งหมด</MenuItem>
              <MenuItem value={true}>ผู้ที่ได้รับรองคุณสมบัติ</MenuItem>
            </Select>
          </FormControl>
          <Button
            variant="contained"
            color="primary"
            size="small"
            className={classes.buttonViewDetail}
            onClick={handleSearch}
          >
            Search
          </Button>
          <Button
            variant="contained"
            size="small"
            className={classes.buttonViewDetail}
            onClick={handleDownload}
            style={{ marginLeft: 5, backgroundColor: "#F59283", color: "#FFF" }}
          >
            Download
          </Button>
        </div>
        {!editMode && (
          <Avatar variant="rounded" className={classes.rounded}>
            <SettingsIcon
              onClick={() => {
                setEditMode(true);
              }}
            />
          </Avatar>
        )}
        {editMode && (
          <div className={classes.editMode}>
            <div className={classes.editText}>Edit Mode</div>
            <Button
              variant="contained"
              color="primary"
              size="small"
              className={classes.buttonViewDetail}
              onClick={async () => {
                setEditMode(false);
                const body = {
                  configJson: JSON.stringify(layout),
                };

                const res = await DashboardService.updateDashboardLayout(body);

                if (res.status) {
                  alert("Update layout success");
                }
              }}
            >
              Save
            </Button>
          </div>
        )}
      </div>
      <ResponsiveReactGridLayout
        className="layout"
        cols={{ lg: 12, md: 12, sm: 2, xs: 2, xxs: 2 }}
        rowHeight={30}
        layouts={layout}
        isDraggable={editMode}
        onLayoutChange={(layout, layouts) => onLayoutChange(layout, layouts)}
      >
        <div className={classes.wrapChart} key="a" data-grid={defaultlayout[0]}>
          <VisaChart
            data={dashboardData?.endorsementRegionRes}
            onSelectViewAll={() => {
              setFilters([3]);
              console.log("VisaChart");
              handleViewAll();
            }}
          />
        </div>
        {/* <div className={classes.wrapChart} key="b" data-grid={defaultlayout[1]}>
          <RequestChart
            data={dashboardData?.documentTypeRes}
            onSelectViewAll={() => {
              console.log("RequestChart");
              setFilters([2]);
              handleViewAll();
            }}
          />
        </div> */}

        <div className={classes.wrapChart} key="b" data-grid={defaultlayout[1]}>
          <RequestTypeChart
            data={dashboardData?.documentTypeRequestRes}
            onSelectViewAll={() => {
              setFilters([2]);
              handleViewAll();
            }}
          />
        </div>
        <div className={classes.wrapChart} key="c" data-grid={defaultlayout[2]}>
          <RequestDocumentChart
            data={dashboardData?.documentStatusRequestRes}
            onSelectViewAll={() => {
              setFilters([]);
              handleViewAll();
            }}
          />
        </div>
        {/* <div className={classes.wrapChart} key="c" data-grid={defaultlayout[2]}>
          <TypeOfVisaChart data={dashboardData?.visaTypeRes} onSelectViewAll={() => {
            console.log('TypeOfVisaChart');
            setFilters([1])
            handleViewAll();
          }} />
        </div> */}

        <div className={classes.wrapChart} key="d" data-grid={defaultlayout[3]}>
          <CheckStatus
            data={dashboardData?.documentListRes}
            onSelectViewAll={() => {
              console.log("CheckStatus");
              setFilters([]);
              handleViewAll();
            }}
          />
        </div>
        <div className={classes.wrapChart} key="e" data-grid={defaultlayout[4]}>
          <CertifyingAgency
            data={dashboardData?.departmentResultRes}
            onSelectViewAll={() => {
              console.log("CertifyingAgency");
              setFilters([]);
              handleViewAll();
            }}
          />
        </div>
        <div className={classes.wrapChart} key="f" data-grid={defaultlayout[5]}>
          <DocumentNationality
            data={dashboardData?.documentNationalityRequestRes}
            onSelectViewAll={() => {
              setFilters([]);
              handleViewAll();
            }}
          />
        </div>

        {/* <div className={classes.wrapChart} key="f" data-grid={defaultlayout[5]}>
          <News
            onSelectViewAll={() => {
              console.log("News");
              handleViewAll();
            }}
          />
        </div> */}
        <div className={classes.wrapChart} key="g" data-grid={defaultlayout[6]}>
          <Notifications
            data={dashboardData?.notificationsRes}
            onSelectViewAll={() => {
              console.log("Notifications");
              setFilters([]);
              handleViewAll();
            }}
          />
        </div>
        {/* <div className={classes.wrapChart} key="h" data-grid={defaultlayout[7]}>
          <Webboard
            onSelectViewAll={() => {
              console.log("Webboard");
              handleViewAll();
            }}
          />
        </div> */}

        <div className={classes.wrapChart} key="i" data-grid={defaultlayout[8]}>
          {dashboardData?.resultQualificationEndorsementRes && (
            <Endorsement
              data={dashboardData?.resultQualificationEndorsementRes}
              onSelectViewAll={() => {
                console.log("Endorsement");
                setFilters([]);
                handleViewAll();
              }}
            />
          )}
        </div>
        {/* <div className={classes.wrapChart} key="j" data-grid={defaultlayout[9]}>
          <Industry
            data={dashboardData?.topIndustriesRes}
            onSelectViewAll={() => {
              console.log("Industry");
              setFilters([4]);
              handleViewAll();
            }}
          />
        </div> */}
      </ResponsiveReactGridLayout>
    </Paper>
  );
}

export default withAdminLayout(DashboardPage);

// function getFromLS(key) {
//   let ls = {};
//   if (global.localStorage) {
//     try {
//       ls = JSON.parse(global.localStorage.getItem("rgl-8")) || {};
//     } catch (e) {
//       /*Ignore*/
//     }
//   }
//   return ls[key];
// }

// function saveToLS(key, value) {
//   if (global.localStorage) {
//     global.localStorage.setItem(
//       "rgl-8",
//       JSON.stringify({
//         [key]: value
//       })
//     );
//   }
// }

function DashboardDetailDialog(props) {
  const classes = makeStyles((theme) => ({
    wrapDialog: {
      height: 64,
    },
    wrapContent: {
      padding: 15,
    },
    appBar: {
      position: "relative",
    },
    title: {
      marginLeft: theme.spacing(2),
      flex: 1,
    },
    formControl: {
      width: "100%",
      marginTop: 5,
      marginBottom: 5,
      paddingLeft: "5px",
      paddingRight: "5px",
    },
    wrapFilter: {
      borderTop: "1px solid lightgray",
      borderBottom: "1px solid lightgray",
    },
    nested: {
      paddingLeft: "30px",
      paddingBottom: "0px",
      paddingTop: "0px",
    },
    iconnested: {
      minWidth: 42,
    },
    checkbox: {
      width: 36,
      height: 36,
    },
    listItemText: {
      fontSize: "0.9em", //Insert your required size
    },
    showmore: {
      color: "#1094d8",
      paddingLeft: "40px",
      marginTop: "15px",
      fontWeight: "500",
      cursor: "pointer",
    },
    rootlist: {
      border: "1px solid lightgray",
      paddingTop: 0,
      borderTop: "0px",
      maxHeight: "90vh",
      overflow: "auto",
    },
    tableHead: {
      color: "black",
      backgroundColor: "white",
      fontWeight: "500",
      width: "1%",
      whiteSpace: "nowrap",
    },
    tableCell: {
      backgroundColor: "white",
      borderBottom: "1px solid rgba(224, 224, 224, 0.5)",
      width: "1%",
      whiteSpace: "nowrap",
    },
    p0: {
      padding: 0,
    },
    tag: {
      display: "inline-block",
      padding: "5px 15px",
      borderRadius: "5px",
      border: "1px solid #40b8d4",
      fontSize: "13px",
      marginRight: "15px",
      backgroundColor: "white",
      color: "#40b8d4",
      fontWeight: "500",
      marginBottom: 10,
    },
  }))();

  const { onClose, open, filters } = props;

  const masterData = useSelector(selectMasterData);
  // const smartservice = get(masterData, "smartservice", []);
  // const visaTypeConfig = get(masterData, "visaTypeConfig", []);
  const activitiesConfig = get(masterData, "activitiesConfig", []);

  const smartServices = [
    {
      name: "Smart T",
      smartServiceId: VISA_TYPE_ID.SMART_T,
    },
    {
      name: "Smart E",
      smartServiceId: VISA_TYPE_ID.SMART_E,
    },
    {
      name: "Smart I",
      smartServiceId: VISA_TYPE_ID.SMART_I,
    },
    {
      name: "Smart S",
      smartServiceId: VISA_TYPE_ID.SMART_S,
    },
    {
      name: "Smart O",
      smartServiceId: VISA_TYPE_ID.SMART_O,
    },
  ];

  const visaTypes = [
    {
      name: "Pending",
      id: "P",
    },
    {
      name: "Change",
      id: "Change",
    },
    {
      name: "Extension",
      id: "Extension",
    },
    {
      name: "Status Report",
      id: "StatusReport",
    },
    {
      name: "Terminate",
      id: "Terminate",
    },
  ];

  const locations = [
    {
      name: "In-Country",
      id: "in",
    },
    {
      name: "Overseas",
      id: "out",
    },
  ];

  const [smartServicesData, setSmartServicesData] = useState(
    smartServices?.map((x) => ({
      ...x,
      checked: filters.find((x1) => x1 === 1),
    }))
  );
  const [visaTypesData, setVisaTypesData] = useState(
    visaTypes?.map((x) => ({ ...x, checked: filters.find((x1) => x1 === 2) }))
  );
  const [locationsData, setLocationsData] = useState(
    locations?.map((x) => ({ ...x, checked: filters.find((x1) => x1 === 3) }))
  );
  const [industryData, setIndustryData] = useState(
    activitiesConfig?.map((x) => ({
      ...x,
      checked: filters.find((x1) => x1 === 4),
    }))
  );

  const [Data, setData] = useState([]);

  useEffect(() => {
    if (activitiesConfig.length > 0) {
      setIndustryData(
        activitiesConfig?.map((x) => ({
          ...x,
          checked: filters.find((x1) => x1 === 4),
        }))
      );
    }
  }, [activitiesConfig]);

  useEffect(async () => {
    if (open) {
      setSmartServicesData(
        smartServices?.map((x) => ({
          ...x,
          checked: filters.find((x1) => x1 === 1),
        }))
      );
      setVisaTypesData(
        visaTypes?.map((x) => ({
          ...x,
          checked: filters.find((x1) => x1 === 2),
        }))
      );
      setLocationsData(
        locations?.map((x) => ({
          ...x,
          checked: filters.find((x1) => x1 === 3),
        }))
      );
      setIndustryData(
        activitiesConfig?.map((x) => ({
          ...x,
          checked: filters.find((x1) => x1 === 4),
        }))
      );

      await fetchData();
    }
  }, [open]);

  const [personName, setPersonName] = React.useState([]);
  const [showmore, setshowmore] = React.useState(false);
  const [open1, setOpen1] = React.useState(true);
  const [open2, setOpen2] = React.useState(true);
  const [open3, setOpen3] = React.useState(true);
  const [open4, setOpen4] = React.useState(true);
  const [open5, setOpen5] = React.useState(true);
  const [open6, setOpen6] = React.useState(true);

  const handleClose = () => {
    onClose();
  };

  const validationSchema = yup.object({
    empId: yup.string().required("Employee is required."),
    // startDate: yup.date().required("Date is required."),
    // remark: yup.string().required("Holiday name is required."),
  });

  const formik = useFormik({
    enableReinitialize: true,
    validationSchema,
    initialValues: {
      startDate: props.startDate,
      endDate: props.endDate,
    },
    onSubmit: async (c) => {
      console.log(c);
    },
  });

  const fetchData = async () => {
    const body = {
      startDate: formik.values?.startDate
        ? format(new Date(formik.values?.startDate), "yyyy-MM-dd")
        : null,
      endDate: formik.values?.endDate
        ? format(new Date(formik.values?.endDate), "yyyy-MM-dd")
        : null,
      industryId: formik.values.activity,
    };

    const res = await ReportService.getReportDataIndustry(body);

    if (res.status) {
      setData(res.results);
    }
  };

  const handleChange = (event) => {
    const {
      target: { value },
    } = event;
    setPersonName(
      // On autofill we get a stringified value.
      typeof value === "string" ? value.split(",") : value
    );
  };
  return (
    <Dialog
      onClose={handleClose}
      aria-labelledby="simple-dialog-title"
      open={open}
      fullWidth={true}
      TransitionComponent={Transition}
      fullScreen
      maxWidth="lg"
      style={{ paddingTop: 0 }}
    >
      {/* <AppBar className={clsx(classes.appBar, classes.wrapDialog)}>
        <Toolbar>
          <IconButton edge="start" color="inherit" onClick={handleClose} aria-label="close">
            <CloseIcon />
          </IconButton>
          <Typography variant="h6" className={classes.title}>
            Document List
          </Typography>

        </Toolbar>
      </AppBar> */}
      <div className={classes.wrapContent}>
        <Grid container spacing={3}>
          <Grid item xs={12} lg={2}>
            <List
              component="nav"
              style={{ borderTop: "0" }}
              aria-labelledby="dashboard-filter"
              // subheader={
              //   <ListSubheader component="div" id="dashboard-filter">
              //     Filter
              //   </ListSubheader>
              // }
              className={classes.rootlist}
            >
              <ListItem
                button
                className={classes.wrapFilter}
                onClick={() => {
                  setOpen6(!open6);
                }}
              >
                <ListItemIcon>
                  <WebIcon />
                </ListItemIcon>
                <ListItemText primary="Period" />
                {open6 ? <ExpandLess /> : <ExpandMore />}
              </ListItem>
              <Collapse in={open6} timeout="auto" unmountOnExit>
                <FormControl variant="outlined" className={classes.formControl}>
                  <DatePicker
                    className={classes.formControl}
                    inputVariant="outlined"
                    openTo="year"
                    format="DD-MM-YYYY"
                    label="Start Date"
                    views={["year", "month", "date"]}
                    name={`startDate`}
                    value={get(formik.values, `startDate`, null) || null}
                    onChange={(date) => {
                      formik.setFieldValue(
                        `startDate`,
                        date.format("YYYY-MM-DD")
                      );
                    }}
                    error={isError(`startDate`)}
                  />
                </FormControl>
                <FormControl variant="outlined" className={classes.formControl}>
                  <DatePicker
                    className={classes.formControl}
                    inputVariant="outlined"
                    openTo="year"
                    format="DD-MM-YYYY"
                    label="End Date"
                    views={["year", "month", "date"]}
                    name={`endDate`}
                    value={get(formik.values, `endDate`, null) || null}
                    onChange={(date) => {
                      formik.setFieldValue(
                        `endDate`,
                        date.format("YYYY-MM-DD")
                      );
                    }}
                    error={isError(`endDate`)}
                  />
                </FormControl>
              </Collapse>

              <ListItem
                button
                className={classes.wrapFilter}
                onClick={() => {
                  setOpen1(!open1);
                }}
              >
                <ListItemIcon>
                  <WebIcon />
                </ListItemIcon>
                <ListItemText primary="Smart Type" />
                {open1 ? <ExpandLess /> : <ExpandMore />}
              </ListItem>
              <Collapse in={open1} timeout="auto" unmountOnExit>
                <List component="div" disablePadding>
                  {smartServicesData?.map((s, index) => (
                    <ListItem
                      button
                      className={classes.nested}
                      key={s.smartServiceId}
                    >
                      <ListItemIcon className={classes.iconnested}>
                        <Checkbox
                          checked={s.checked}
                          tabIndex={-1}
                          disableRipple
                          classes={{ root: "dashboard-custom-checkbox-root" }}
                          onClick={async (event) => {
                            const groups = smartServicesData.map(
                              (item, index2) =>
                                index === index2
                                  ? { ...item, checked: event.target.checked }
                                  : item
                            );
                            console.log(groups);
                            setSmartServicesData(groups);
                          }}
                        />
                      </ListItemIcon>
                      <ListItemText
                        primary={s.name}
                        classes={{ primary: classes.listItemText }}
                      />
                    </ListItem>
                  ))}
                </List>
              </Collapse>

              <ListItem
                button
                className={classes.wrapFilter}
                onClick={() => {
                  setOpen2(!open2);
                }}
              >
                <ListItemIcon>
                  <AssignmentIndIcon />
                </ListItemIcon>
                <ListItemText primary="Visa Type" />
                {open2 ? <ExpandLess /> : <ExpandMore />}
              </ListItem>
              <Collapse in={open2} timeout="auto" unmountOnExit>
                <List component="div" disablePadding>
                  {visaTypesData?.map((s, index) => (
                    <ListItem button className={classes.nested} key={s.id}>
                      <ListItemIcon className={classes.iconnested}>
                        <Checkbox
                          checked={s.checked}
                          tabIndex={-1}
                          disableRipple
                          classes={{ root: "dashboard-custom-checkbox-root" }}
                          onClick={async (event) => {
                            const groups = visaTypesData.map((item, index2) =>
                              index === index2
                                ? { ...item, checked: event.target.checked }
                                : item
                            );
                            console.log(groups);
                            setVisaTypesData(groups);
                          }}
                        />
                      </ListItemIcon>
                      <ListItemText
                        primary={s.name}
                        classes={{ primary: classes.listItemText }}
                      />
                    </ListItem>
                  ))}
                </List>
              </Collapse>

              <ListItem
                button
                className={classes.wrapFilter}
                onClick={() => {
                  setOpen3(!open3);
                }}
              >
                <ListItemIcon>
                  <MyLocationIcon />
                </ListItemIcon>
                <ListItemText primary="Location" />
                {open3 ? <ExpandLess /> : <ExpandMore />}
              </ListItem>
              <Collapse in={open3} timeout="auto" unmountOnExit>
                <List component="div" disablePadding>
                  {locationsData?.map((a, index) => (
                    <ListItem button className={classes.nested} key={a.id}>
                      <ListItemIcon className={classes.iconnested}>
                        <Checkbox
                          checked={a.checked}
                          tabIndex={-1}
                          disableRipple
                          classes={{ root: "dashboard-custom-checkbox-root" }}
                          onClick={async (event) => {
                            const groups = locationsData.map((item, index2) =>
                              index === index2
                                ? { ...item, checked: event.target.checked }
                                : item
                            );
                            console.log(groups);
                            setLocationsData(groups);
                          }}
                        />
                      </ListItemIcon>
                      <ListItemText
                        primary={a.name}
                        classes={{ primary: classes.listItemText }}
                      />
                    </ListItem>
                  ))}
                </List>
              </Collapse>

              <ListItem
                button
                className={classes.wrapFilter}
                onClick={() => {
                  setOpen5(!open5);
                }}
              >
                <ListItemIcon>
                  <GroupAddIcon />
                </ListItemIcon>
                <ListItemText primary="Industry" />
                {open5 ? <ExpandLess /> : <ExpandMore />}
              </ListItem>
              <Collapse in={open5} timeout="auto" unmountOnExit>
                <List
                  component="div"
                  disablePadding
                  style={{
                    height: showmore ? "auto" : "250px",
                    overflow: "hidden",
                  }}
                >
                  {industryData?.map((a, index) => (
                    <ListItem
                      button
                      className={classes.nested}
                      key={a.activitiesId}
                    >
                      <ListItemIcon className={classes.iconnested}>
                        <Checkbox
                          checked={a.checked}
                          tabIndex={-1}
                          disableRipple
                          classes={{ root: "dashboard-custom-checkbox-root" }}
                          onClick={async (event) => {
                            const groups = industryData.map((item, index2) =>
                              index === index2
                                ? { ...item, checked: event.target.checked }
                                : item
                            );
                            console.log(groups);
                            setIndustryData(groups);
                          }}
                        />
                      </ListItemIcon>
                      <ListItemText
                        primary={a.activitiesName}
                        classes={{ primary: classes.listItemText }}
                      />
                    </ListItem>
                  ))}
                </List>
                {!showmore && (
                  <div
                    className={classes.showmore}
                    onClick={() => {
                      setshowmore(true);
                    }}
                  >
                    Show More
                  </div>
                )}
                {showmore && (
                  <div
                    className={classes.showmore}
                    onClick={() => {
                      setshowmore(false);
                    }}
                  >
                    Show Less
                  </div>
                )}
              </Collapse>
            </List>
          </Grid>
          <Grid item xs={12} lg={10}>
            <div style={{ display: "flex", alignItems: "flex-start" }}>
              <div style={{ flex: 1 }}>
                {smartServicesData
                  .filter((x) => x.checked)
                  .map((x) => (
                    <div className={classes.tag} key={x.smartServiceId}>
                      {x.name}
                    </div>
                  ))}

                {visaTypesData
                  .filter((x) => x.checked)
                  .map((x) => (
                    <div className={classes.tag} key={x.id}>
                      {x.name}
                    </div>
                  ))}

                {locationsData
                  .filter((x) => x.checked)
                  .map((x) => (
                    <div className={classes.tag} key={x.id}>
                      {x.name}
                    </div>
                  ))}

                {industryData
                  .filter((x) => x.checked)
                  .map((x) => (
                    <div className={classes.tag} key={x.activitiesId}>
                      {x.activitiesName}
                    </div>
                  ))}
              </div>
              <div
                style={{ textAlign: "right", cursor: "pointer", flexBasis: 48 }}
              >
                <IconButton
                  edge="start"
                  color="inherit"
                  onClick={handleClose}
                  aria-label="close"
                >
                  <CloseIcon />
                </IconButton>
              </div>
            </div>

            <div>
              <TableContainer
                component={Paper}
                style={{ borderRadius: 0, maxHeight: "75vh" }}
              >
                <Table
                  stickyHeader
                  className={classes.table}
                  size="small"
                  aria-label="a dense table"
                >
                  <TableHead>
                    <StyledTableRow>
                      <TableCell className={classes.tableHead}>Date</TableCell>
                      <TableCell className={classes.tableHead}>
                        Doc No.
                      </TableCell>
                      <TableCell className={classes.tableHead}>
                        First Name
                      </TableCell>
                      <TableCell className={classes.tableHead}>
                        Last Name
                      </TableCell>
                      <TableCell className={classes.tableHead}>Email</TableCell>
                      <TableCell className={classes.tableHead}>
                        Visa Type
                      </TableCell>
                      <TableCell className={classes.tableHead}>
                        Status
                      </TableCell>
                      <TableCell className={classes.tableHead}>Staff</TableCell>
                      <TableCell className={classes.tableHead}>
                        Industry
                      </TableCell>
                    </StyledTableRow>
                  </TableHead>
                  <TableBody>
                    {Data.map((row) => (
                      <StyledTableRow key={row.draftId}>
                        <TableCell
                          className={classes.tableCell}
                          component="th"
                          scope="row"
                        >
                          {format(new Date(row.createDate), "yyyy-MM-dd")}
                        </TableCell>
                        <TableCell className={classes.tableCell}>
                          {row.docNo}
                        </TableCell>
                        <TableCell className={classes.tableCell}>
                          {row.personalFirstName}
                        </TableCell>
                        <TableCell className={classes.tableCell}>
                          {row.personalLastName}
                        </TableCell>
                        <TableCell className={classes.tableCell}>
                          {row.personalEmail}
                        </TableCell>
                        <TableCell className={classes.tableCell}>
                          {row.visaType}
                        </TableCell>
                        <TableCell className={classes.tableCell}>
                          {row.docStatus}
                        </TableCell>
                        <TableCell className={classes.tableCell}>
                          {row.staffFirstName} {row.staffLastName}
                        </TableCell>
                        <TableCell className={classes.tableCell}>
                          {row.industryName}
                        </TableCell>
                      </StyledTableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </div>
          </Grid>
        </Grid>
      </div>
    </Dialog>
  );
}

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};
